export const DropdownOptions = {
    placeholder: 'מזומן',
    mainContent: null,
    setDisplayedData: null,
    data: [
        {
            label: 'מזומן',
            action: null
        },
        {
            label: 'צ׳ק',
            action: null
        }
    ],
    setup(mainContentRef, setDisplayedDataRef) {
        this.mainContent = mainContentRef;
        this.setDisplayedData = setDisplayedDataRef;
        // this.data[0].action = () => {
        // const sortedData = sortCustomersByField(this.mainContent, 'customer');
        // this.setDisplayedData(sortedData);
        // };
    }
};
